import { TokensMath } from '../../../Fct/plugins/tokensMath';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var MultiDivider = createMulticallPlugin({
    plugin: TokensMath.getters.Divide,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY:VIEWONLY',
    method: 'multiCall',
    name: 'multiDivider',
    config: {
        params: [
            { key: 'methodParams.numerator', multicallKey: 'amount1', isPreview: true },
            { key: 'methodParams.decimals1', multicallKey: 'decimals1' },
            { key: 'methodParams.denominator', multicallKey: 'amount2', isPreview: true },
            { key: 'methodParams.decimals2', multicallKey: 'decimals2' },
            { key: 'methodParams.decimalsOut', multicallKey: 'decimalsOut' },
        ],
        tupleName: 'divs',
    },
    addPluginOnInit: true,
    withPluginOutputs: true,
});
